/* eslint-disable dot-notation */
import React, { useEffect, useState } from 'react';

import { Container, Typography, makeStyles } from '@material-ui/core';
import queryString from 'query-string';
import { useLocation, useParams } from 'react-router-dom';

import { loadingStatus } from '../../blocs/videoReport.bloc';
import Footer from '../../components/footer/Footer';
import RegisterHeader from '../../components/register/RegisterHeader';
import VideoReportContent from '../../components/videoReport/VideoReportContent';
import VideoReportLoading from '../../components/videoReport/VideoReportLoading';
import useBlocRefHook from '../../utils/useBlocRef.hook';

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    textAlign: 'left',
  },
  mainContainer: {
    margin: 'auto',
    maxWidth: '715px',
    padding: '16px 24px',
  },
  parentContainer: {
    display: 'grid',
    minHeight: '100vh',
  },
  parentContainerNoFooter: {
    display: 'grid',
    minHeight: '95vh',
  },
  title: {
    color: '#172B4D',
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '27px',
    [theme.breakpoints.up('md')]: {
      fontSize: '24px',
      lineHeight: '36px',
    },
  },
  videoContainer: {
    marginTop: '16px',
  },
}));

export default () => {
  const classes = useStyles();
  const blocRef = useBlocRefHook('videoReportBloc');

  const [resourceDetail, setResourceDetail] = useState(null);
  const [resourceDetailLoading, setResourceDetailLoading] = useState('idle');
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  const { resourceId } = useParams();
  const { search } = useLocation();
  const parsedQueryString = queryString.parse(search);

  useEffect(() => {
    const resourceDetailSub = blocRef.current.resourceDetail$.subscribe(setResourceDetail);
    const resourceDetailLoadingSub = blocRef.current.resourceDetailLoading$.subscribe(setResourceDetailLoading);
    const isFooterVisibleSub = blocRef.current.isFooterVisible$.subscribe(setIsFooterVisible);
    blocRef.current.getResourceInfo(resourceId, parsedQueryString['$token']);

    return () => {
      resourceDetailSub.unsubsribe();
      resourceDetailLoadingSub.unsubscribe();
      isFooterVisibleSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderLoading = () => {
    return <VideoReportLoading />;
  };

  const renderSharedVideoReport = () => {
    return <VideoReportContent videoData={resourceDetail?.videoData} resourceId={resourceDetail.id} />;
  };

  const renderVideoReportFetchFailed = () => {
    return (
      <Typography className={classes.title} align="center">
        We can&lsquo;t find any video report data.
      </Typography>
    );
  };

  const setupElementToRender = {
    [loadingStatus.idle]: renderLoading,
    [loadingStatus.loading]: renderLoading,
    [loadingStatus.error]: renderVideoReportFetchFailed,
    [loadingStatus.success]: renderSharedVideoReport,
  };

  return (
    <div className={isFooterVisible ? classes.parentContainer : classes.parentContainerNoFooter}>
      <RegisterHeader />

      <Container className={classes.mainContainer} maxWidth={false}>
        <div className={classes.contentContainer}>{setupElementToRender[resourceDetailLoading]()}</div>
      </Container>

      <div style={{ marginTop: 'auto' }}>{isFooterVisible && <Footer />}</div>
    </div>
  );
};
